module.exports = __webpack_public_path__ + "img/azul.9e0f0423.svg";